// useRecorder.js
import { useState, useRef } from "react";

import MediaRecorder from 'opus-media-recorder';
// You should use file-loader in webpack.config.js.
// See webpack example link in the above section for more detail.
import OggOpusWasm from 'opus-media-recorder/OggOpusEncoder.wasm';
import WebMOpusWasm from 'opus-media-recorder/WebMOpusEncoder.wasm';

const workerOptions = {
    OggOpusEncoderWasmPath: OggOpusWasm,
    WebMOpusEncoderWasmPath: WebMOpusWasm
};

export default function useRecorder() {
    const [recording, setRecording]   = useState(false);
    const [blob, setBlob]     = useState(null);
    const mediaRef   = useRef(null);
    const chunksRef  = useRef([]);

    const mime ="audio/ogg;codecs=opus"

    const start = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const rec = new MediaRecorder(stream, { mimeType: mime }, workerOptions);

        console.log("recorder", rec);

        chunksRef.current = [];

        rec.ondataavailable = (e) => e.data.size && chunksRef.current.push(e.data);
        rec.onstop = () => {
            setBlob(new Blob(chunksRef.current, { type: mime }));
        };

        rec.start(1000); // 1 초마다 chunk 생성(실시간 스트림용)
        mediaRef.current = rec;
        setRecording(true);
    };

    const stop = () => {
        mediaRef.current?.stop();
        setRecording(false);
    };

    return { start, stop, recording, blob, setBlob };
}
